export default {"src":"__ASTRO_ASSET_IMAGE__kBU$0BGo__","width":720,"height":330,"format":"png"}